<h1>Find your Workout Plan</h1>
<section id="lift-tracker">
    <h2>A Strong Runner is a Fast Runner</h2>
    <p>
        Runners with noodle arms and noodle legs may be able to run far, but push comes to shove if you want to be fast, you need to lift and get some strength training!
    </p>
    <p>If you are a beginner, we can help you get started!
        Let's start off by telling us your preferred workout plan.
    </p>
</section>
<section id="select-bodybuilding">
    <div class="row">
        <div class="col-lg-6">
            <h2 class="card-title">Bodybuilding</h2>
            <p class="card-text">
                You will be prescribed a bodybuilding based workout plan. This plan could work on
                building your muscles through scheduled workouts and meal plans.
            </p>
        </div>
        <div class="col-lg-6">
            <cite><img src="assets/images/backgrounds/sebastian-pociecha-FoSF9-4xTGg-unsplash.png"  class="img-responsive" class="card-img-top"alt="home-gym-img"></cite>
        </div>
    </div>
</section>
<section id="select-strength">
    <div class="row">
        <div class="col-lg-6">
            <h2 class="card-title">Strength</h2>
            <p class="card-text">
                You will be prescribed a powerlifting based work out plan. This plan works on your
                strength gains and will be require you to be increasing in weights weekly.
            </p>
        </div>
        <div class="col-lg-6">
            <cite><img src="assets/images/backgrounds/victor-freitas-Yuv-iwByVRQ-unsplash.png" class="img-responsive" class="card-img-top" alt="barbell-img"></cite>
        </div>
    </div>
</section>
<section id="select-functional">
    <div class="row">
        <div class="col-lg-6">
            <h2 class="card-title">Functional</h2>
            <p class="card-text">
                You will be prescribed a crossfit based workout plan. You will train hard with these
                workouts. This will include workouts that require endurance, strength, and speed.
            </p>
        </div>
        <div class="col-lg-6">
            <cite><img src="assets/images/backgrounds/logan-weaver-pYQ2ASycjgI-unsplash.png" class="img-responsive" class="card-img-top" alt="crossfit-img"></cite>
        </div>
    </div>
</section>
<section>
    <h2>Ready to Get Strong?</h2>
    <p>It may not be easy but with our workout plans we can keep things simple! Work harder and smarter with us so we can help you achieve your fitness goals!</p>
    <a routerLink='/your-workout-plan'><button id="checkout-workout-plans-btn">Checkout our Workout Plans</button></a>
</section>